import { Link } from "@material-ui/core";
import styled from "styled-components";

export const SecondaryLink = styled(Link)`
  ${({ theme }) => `
    color: ${theme.palette.link.secondary};
    text-decoration: underline;
    `}
`;
